import {observer} from 'mobx-react';
import Subnav from '../../Subnav';
import NmbrEmployeesDirectoryWithState from './NmbrEmployeesDirectoryWithState';

const NmbrEmployeesDirectory = observer(({erroredNmbrEmployees}) => {
  return (
    <div>
      <Subnav/>
      <NmbrEmployeesDirectoryWithState erroredNmbrEmployees={erroredNmbrEmployees}/>
    </div>
  );
});

export default NmbrEmployeesDirectory;
